"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersManagementControllerListUsersV1IsDeletedEnum = exports.UsersManagementControllerListUsersV1IsActiveEnum = exports.UsersManagementControllerListUsersV1IsRecentEnum = exports.UsersManagementControllerListUserCompetitionsV1SortByReportsCountEnum = exports.UsersManagementControllerListUserCompetitionsV1SortByVotesCountEnum = exports.UsersManagementApi = exports.UsersManagementApiFactory = exports.UsersManagementApiFp = exports.UsersManagementApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * UsersManagementApi - axios parameter creator
 * @export
 */
var UsersManagementApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get distinct cities from users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerGetCitiesV1: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/admin/users-management/cities";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get user details
         * @summary Get user details
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerGetUserDetailsV1: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('usersManagementControllerGetUserDetailsV1', 'id', id);
                            localVarPath = "/v1/admin/users-management/user-details/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List competitions a user has participated in
         * @param {string} id
         * @param {number} [page] Page number
         * @param {number} [limit] Limit number
         * @param {UsersManagementControllerListUserCompetitionsV1SortByVotesCountEnum} [sortByVotesCount] sort by votes count
         * @param {UsersManagementControllerListUserCompetitionsV1SortByReportsCountEnum} [sortByReportsCount] sort by reports count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerListUserCompetitionsV1: function (id_1, page_1, limit_1, sortByVotesCount_1, sortByReportsCount_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, page_1, limit_1, sortByVotesCount_1, sortByReportsCount_1], args_1, true), void 0, function (id, page, limit, sortByVotesCount, sortByReportsCount, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('usersManagementControllerListUserCompetitionsV1', 'id', id);
                            localVarPath = "/v1/admin/users-management/{id}/competitions"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortByVotesCount !== undefined) {
                                localVarQueryParameter['sort_by_votes_count'] = sortByVotesCount;
                            }
                            if (sortByReportsCount !== undefined) {
                                localVarQueryParameter['sort_by_reports_count'] = sortByReportsCount;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List users with pagination and search
         * @param {number} [page] Page number
         * @param {number} [limit] Limit number
         * @param {string} [search] Search by id, name, phone, city
         * @param {UsersManagementControllerListUsersV1IsRecentEnum} [isRecent] Sort by created_at: asc or desc
         * @param {UsersManagementControllerListUsersV1IsActiveEnum} [isActive] Filter by is_active: true or false
         * @param {UsersManagementControllerListUsersV1IsDeletedEnum} [isDeleted] Filter by is_deleted: deleted, not_deleted, or all
         * @param {Array<any>} [cities] Filter by cities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerListUsersV1: function (page_1, limit_1, search_1, isRecent_1, isActive_1, isDeleted_1, cities_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, limit_1, search_1, isRecent_1, isActive_1, isDeleted_1, cities_1], args_1, true), void 0, function (page, limit, search, isRecent, isActive, isDeleted, cities, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/admin/users-management/users";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (isRecent !== undefined) {
                                localVarQueryParameter['is_recent'] = isRecent;
                            }
                            if (isActive !== undefined) {
                                localVarQueryParameter['is_active'] = isActive;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['is_deleted'] = isDeleted;
                            }
                            if (cities) {
                                localVarQueryParameter['cities'] = cities;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update user delete status (soft-delete or restore)
         * @param {string} id
         * @param {UpdateUserDeleteStatusRequestDto} updateUserDeleteStatusRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerUpdateUserDeleteStatusV1: function (id_1, updateUserDeleteStatusRequestDto_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, updateUserDeleteStatusRequestDto_1], args_1, true), void 0, function (id, updateUserDeleteStatusRequestDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('usersManagementControllerUpdateUserDeleteStatusV1', 'id', id);
                            // verify required parameter 'updateUserDeleteStatusRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('usersManagementControllerUpdateUserDeleteStatusV1', 'updateUserDeleteStatusRequestDto', updateUserDeleteStatusRequestDto);
                            localVarPath = "/v1/admin/users-management/{id}/delete-status"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUserDeleteStatusRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update user active status
         * @param {string} id
         * @param {UpdateUserStatusRequestDto} updateUserStatusRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerUpdateUserStatusV1: function (id_1, updateUserStatusRequestDto_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, updateUserStatusRequestDto_1], args_1, true), void 0, function (id, updateUserStatusRequestDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('usersManagementControllerUpdateUserStatusV1', 'id', id);
                            // verify required parameter 'updateUserStatusRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('usersManagementControllerUpdateUserStatusV1', 'updateUserStatusRequestDto', updateUserStatusRequestDto);
                            localVarPath = "/v1/admin/users-management/{id}/status"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUserStatusRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UsersManagementApiAxiosParamCreator = UsersManagementApiAxiosParamCreator;
/**
 * UsersManagementApi - functional programming interface
 * @export
 */
var UsersManagementApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UsersManagementApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get distinct cities from users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerGetCitiesV1: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersManagementControllerGetCitiesV1(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersManagementApi.usersManagementControllerGetCitiesV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get user details
         * @summary Get user details
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerGetUserDetailsV1: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersManagementControllerGetUserDetailsV1(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersManagementApi.usersManagementControllerGetUserDetailsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List competitions a user has participated in
         * @param {string} id
         * @param {number} [page] Page number
         * @param {number} [limit] Limit number
         * @param {UsersManagementControllerListUserCompetitionsV1SortByVotesCountEnum} [sortByVotesCount] sort by votes count
         * @param {UsersManagementControllerListUserCompetitionsV1SortByReportsCountEnum} [sortByReportsCount] sort by reports count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerListUserCompetitionsV1: function (id, page, limit, sortByVotesCount, sortByReportsCount, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersManagementControllerListUserCompetitionsV1(id, page, limit, sortByVotesCount, sortByReportsCount, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersManagementApi.usersManagementControllerListUserCompetitionsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List users with pagination and search
         * @param {number} [page] Page number
         * @param {number} [limit] Limit number
         * @param {string} [search] Search by id, name, phone, city
         * @param {UsersManagementControllerListUsersV1IsRecentEnum} [isRecent] Sort by created_at: asc or desc
         * @param {UsersManagementControllerListUsersV1IsActiveEnum} [isActive] Filter by is_active: true or false
         * @param {UsersManagementControllerListUsersV1IsDeletedEnum} [isDeleted] Filter by is_deleted: deleted, not_deleted, or all
         * @param {Array<any>} [cities] Filter by cities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerListUsersV1: function (page, limit, search, isRecent, isActive, isDeleted, cities, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersManagementControllerListUsersV1(page, limit, search, isRecent, isActive, isDeleted, cities, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersManagementApi.usersManagementControllerListUsersV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update user delete status (soft-delete or restore)
         * @param {string} id
         * @param {UpdateUserDeleteStatusRequestDto} updateUserDeleteStatusRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerUpdateUserDeleteStatusV1: function (id, updateUserDeleteStatusRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersManagementControllerUpdateUserDeleteStatusV1(id, updateUserDeleteStatusRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersManagementApi.usersManagementControllerUpdateUserDeleteStatusV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update user active status
         * @param {string} id
         * @param {UpdateUserStatusRequestDto} updateUserStatusRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerUpdateUserStatusV1: function (id, updateUserStatusRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersManagementControllerUpdateUserStatusV1(id, updateUserStatusRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersManagementApi.usersManagementControllerUpdateUserStatusV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UsersManagementApiFp = UsersManagementApiFp;
/**
 * UsersManagementApi - factory interface
 * @export
 */
var UsersManagementApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UsersManagementApiFp)(configuration);
    return {
        /**
         *
         * @summary Get distinct cities from users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerGetCitiesV1: function (options) {
            return localVarFp.usersManagementControllerGetCitiesV1(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get user details
         * @summary Get user details
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerGetUserDetailsV1: function (id, options) {
            return localVarFp.usersManagementControllerGetUserDetailsV1(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List competitions a user has participated in
         * @param {string} id
         * @param {number} [page] Page number
         * @param {number} [limit] Limit number
         * @param {UsersManagementControllerListUserCompetitionsV1SortByVotesCountEnum} [sortByVotesCount] sort by votes count
         * @param {UsersManagementControllerListUserCompetitionsV1SortByReportsCountEnum} [sortByReportsCount] sort by reports count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerListUserCompetitionsV1: function (id, page, limit, sortByVotesCount, sortByReportsCount, options) {
            return localVarFp.usersManagementControllerListUserCompetitionsV1(id, page, limit, sortByVotesCount, sortByReportsCount, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List users with pagination and search
         * @param {number} [page] Page number
         * @param {number} [limit] Limit number
         * @param {string} [search] Search by id, name, phone, city
         * @param {UsersManagementControllerListUsersV1IsRecentEnum} [isRecent] Sort by created_at: asc or desc
         * @param {UsersManagementControllerListUsersV1IsActiveEnum} [isActive] Filter by is_active: true or false
         * @param {UsersManagementControllerListUsersV1IsDeletedEnum} [isDeleted] Filter by is_deleted: deleted, not_deleted, or all
         * @param {Array<any>} [cities] Filter by cities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerListUsersV1: function (page, limit, search, isRecent, isActive, isDeleted, cities, options) {
            return localVarFp.usersManagementControllerListUsersV1(page, limit, search, isRecent, isActive, isDeleted, cities, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update user delete status (soft-delete or restore)
         * @param {string} id
         * @param {UpdateUserDeleteStatusRequestDto} updateUserDeleteStatusRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerUpdateUserDeleteStatusV1: function (id, updateUserDeleteStatusRequestDto, options) {
            return localVarFp.usersManagementControllerUpdateUserDeleteStatusV1(id, updateUserDeleteStatusRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update user active status
         * @param {string} id
         * @param {UpdateUserStatusRequestDto} updateUserStatusRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersManagementControllerUpdateUserStatusV1: function (id, updateUserStatusRequestDto, options) {
            return localVarFp.usersManagementControllerUpdateUserStatusV1(id, updateUserStatusRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UsersManagementApiFactory = UsersManagementApiFactory;
/**
 * UsersManagementApi - object-oriented interface
 * @export
 * @class UsersManagementApi
 * @extends {BaseAPI}
 */
var UsersManagementApi = /** @class */ (function (_super) {
    __extends(UsersManagementApi, _super);
    function UsersManagementApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get distinct cities from users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersManagementApi
     */
    UsersManagementApi.prototype.usersManagementControllerGetCitiesV1 = function (options) {
        var _this = this;
        return (0, exports.UsersManagementApiFp)(this.configuration).usersManagementControllerGetCitiesV1(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get user details
     * @summary Get user details
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersManagementApi
     */
    UsersManagementApi.prototype.usersManagementControllerGetUserDetailsV1 = function (id, options) {
        var _this = this;
        return (0, exports.UsersManagementApiFp)(this.configuration).usersManagementControllerGetUserDetailsV1(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List competitions a user has participated in
     * @param {string} id
     * @param {number} [page] Page number
     * @param {number} [limit] Limit number
     * @param {UsersManagementControllerListUserCompetitionsV1SortByVotesCountEnum} [sortByVotesCount] sort by votes count
     * @param {UsersManagementControllerListUserCompetitionsV1SortByReportsCountEnum} [sortByReportsCount] sort by reports count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersManagementApi
     */
    UsersManagementApi.prototype.usersManagementControllerListUserCompetitionsV1 = function (id, page, limit, sortByVotesCount, sortByReportsCount, options) {
        var _this = this;
        return (0, exports.UsersManagementApiFp)(this.configuration).usersManagementControllerListUserCompetitionsV1(id, page, limit, sortByVotesCount, sortByReportsCount, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List users with pagination and search
     * @param {number} [page] Page number
     * @param {number} [limit] Limit number
     * @param {string} [search] Search by id, name, phone, city
     * @param {UsersManagementControllerListUsersV1IsRecentEnum} [isRecent] Sort by created_at: asc or desc
     * @param {UsersManagementControllerListUsersV1IsActiveEnum} [isActive] Filter by is_active: true or false
     * @param {UsersManagementControllerListUsersV1IsDeletedEnum} [isDeleted] Filter by is_deleted: deleted, not_deleted, or all
     * @param {Array<any>} [cities] Filter by cities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersManagementApi
     */
    UsersManagementApi.prototype.usersManagementControllerListUsersV1 = function (page, limit, search, isRecent, isActive, isDeleted, cities, options) {
        var _this = this;
        return (0, exports.UsersManagementApiFp)(this.configuration).usersManagementControllerListUsersV1(page, limit, search, isRecent, isActive, isDeleted, cities, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update user delete status (soft-delete or restore)
     * @param {string} id
     * @param {UpdateUserDeleteStatusRequestDto} updateUserDeleteStatusRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersManagementApi
     */
    UsersManagementApi.prototype.usersManagementControllerUpdateUserDeleteStatusV1 = function (id, updateUserDeleteStatusRequestDto, options) {
        var _this = this;
        return (0, exports.UsersManagementApiFp)(this.configuration).usersManagementControllerUpdateUserDeleteStatusV1(id, updateUserDeleteStatusRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update user active status
     * @param {string} id
     * @param {UpdateUserStatusRequestDto} updateUserStatusRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersManagementApi
     */
    UsersManagementApi.prototype.usersManagementControllerUpdateUserStatusV1 = function (id, updateUserStatusRequestDto, options) {
        var _this = this;
        return (0, exports.UsersManagementApiFp)(this.configuration).usersManagementControllerUpdateUserStatusV1(id, updateUserStatusRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UsersManagementApi;
}(base_1.BaseAPI));
exports.UsersManagementApi = UsersManagementApi;
/**
 * @export
 */
exports.UsersManagementControllerListUserCompetitionsV1SortByVotesCountEnum = {
    Asc: 'asc',
    Desc: 'desc',
    None: 'none'
};
/**
 * @export
 */
exports.UsersManagementControllerListUserCompetitionsV1SortByReportsCountEnum = {
    Asc: 'asc',
    Desc: 'desc',
    None: 'none'
};
/**
 * @export
 */
exports.UsersManagementControllerListUsersV1IsRecentEnum = {
    Asc: 'asc',
    Desc: 'desc',
    All: 'all'
};
/**
 * @export
 */
exports.UsersManagementControllerListUsersV1IsActiveEnum = {
    Active: 'active',
    Inactive: 'inactive',
    All: 'all'
};
/**
 * @export
 */
exports.UsersManagementControllerListUsersV1IsDeletedEnum = {
    Deleted: 'deleted',
    NotDeleted: 'not_deleted',
    All: 'all'
};
